export class Coding {
  constructor(
    public systemId: string,
    public code: string,
    public display: string) { }
}
